// @flow

export const selectRemoveModal = state => state.companyView.modalRemove
export const selectCreatingAddress = state => state.companyView.creatingAddress
export const selectCreateModal = state => state.companyView.modalCreate
export const selectWorking = state => state.companyView.working
